export const isDeployedToProduction = location.hostname === 'booking.quick.md';
